import { useContext } from "react";
import { ProjectSearchPageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(ProjectSearchPageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
